import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import ContactOverrideModal from "../Components/ContactOverrideModal";

const SessionContextContactOverrideModal = SessionContextValueProvider({
  Component: ContactOverrideModal,
  map: ({ lead, previewCustomer, setOverrideContact }) => ({
    contact: lead,
    customer: previewCustomer,
    setOverrideContact
  })
});

export default SessionContextContactOverrideModal;
